import React from 'react';
import { LucideProps } from 'lucide-react';
import { cn } from '../../lib/utils';

export const StarShape = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ color = 'currentColor', size = 24, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className={cn('lucide lucide-star-shape', className)}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path 
          d="m10.3412.305328.2901 2.577772c.384 3.41011 3.0755 6.10161 6.4856 6.48564l2.5778.29008c.4071.04615.4071.63618 0 .68238l-2.5778.2901c-3.4101.384-6.1016 3.0755-6.4856 6.4856l-.2901 2.5778c-.0462.4071-.63623.4071-.68238 0l-.29008-2.5778c-.38403-3.4101-3.07552-6.1016-6.48564-6.4856l-2.577772-.2901c-.407104-.0462-.407104-.63623 0-.68238L2.8831 9.36874c3.41012-.38403 6.10161-3.07553 6.48564-6.48564L9.65882.305328c.04615-.407104.63618-.407104.68238 0Z" 
          fill="url(#starGradient)" 
        />
        <defs>
          <linearGradient id="starGradient" x1="1.89349" y1="-3.84615" x2="25.8174" y2="10.1746" gradientUnits="userSpaceOnUse">
            <stop stopColor="#C1EEE3" />
            <stop offset="1" stopColor="#007A60" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
);

StarShape.displayName = 'StarShape';

export default StarShape;
